export default __webpack_public_path__ + "static/media/BTC_pool.11840117.png";